import { render, staticRenderFns } from "./LogInPage.vue?vue&type=template&id=12c0b2be&scoped=true"
import script from "./LogInPage.vue?vue&type=script&lang=js"
export * from "./LogInPage.vue?vue&type=script&lang=js"
import style0 from "./LogInPage.vue?vue&type=style&index=0&id=12c0b2be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c0b2be",
  null
  
)

export default component.exports